module.exports = __webpack_public_path__ + "img/canada-gc-4.a2bf67de.png";